var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuditEnquiryIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.02,
    height: 15.113,
    viewBox: "0 0 9.02 15.113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_",
    "data-name": " ",
    transform: "translate(-673.111 -372.367)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M676.455,383.19l-.132-3.365.968-.242a4.524,4.524,0,0,0,2.2-1.133,2.562,2.562,0,0,0,.726-1.837,2.255,2.255,0,0,0-.825-1.882,3.336,3.336,0,0,0-2.123-.648,4.141,4.141,0,0,0-1.694.34,3.969,3.969,0,0,0-1.32.935l-1.144-1.1a4.575,4.575,0,0,1,1.738-1.4,5.934,5.934,0,0,1,2.53-.494,5.237,5.237,0,0,1,3.454,1.077,3.755,3.755,0,0,1,1.3,3.058,3.924,3.924,0,0,1-.946,2.684,5.738,5.738,0,0,1-3.058,1.584l-.176,2.42Zm.748,4.29a1.366,1.366,0,0,1-.957-.374,1.3,1.3,0,0,1,0-1.891,1.409,1.409,0,0,1,1.914,0,1.3,1.3,0,0,1,0,1.891A1.366,1.366,0,0,1,677.2,387.48Z",
    fill: "#656565"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditEnquiryIcon);
export default __webpack_public_path__ + "static/media/auditEnquiryIcon.c3ce945d026541085e904669c42a5117.svg";
export { ForwardRef as ReactComponent };